import { render } from "./KamranGallery.vue?vue&type=template&id=a0df0446&scoped=true"
import script from "./KamranGallery.vue?vue&type=script&lang=js"
export * from "./KamranGallery.vue?vue&type=script&lang=js"

import "./KamranGallery.vue?vue&type=style&index=0&id=a0df0446&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0df0446"]])

export default __exports__